// Centralized mock data for the AURA dashboard MVP (frontend-only).
// Real backend wiring will replace these later.

export const USER = {
  name: "Maria",
  initial: "M",
  email: "maria@example.com",
  joined: "2025-09",
  active_language: "Spanish (MX)",
  cefr: "B1.4",
  cefr_value: 1.4, // 0=A1 → 5=C2
  streak: 12,
  voice_print_done: true,
};

export const SIGNALS = [
  { key: "vocab", label: "Vocabulary", value: 78, delta: "+4", tone: "up", history: [62, 64, 66, 68, 71, 73, 74, 76, 77, 78] },
  { key: "gram", label: "Grammar", value: 62, delta: "+2", tone: "up", history: [50, 52, 53, 55, 57, 58, 60, 60, 61, 62] },
  { key: "pron", label: "Pronunciation", value: 71, delta: "—", tone: "flat", history: [68, 69, 70, 70, 71, 71, 71, 71, 71, 71] },
  { key: "flue", label: "Fluency", value: 55, delta: "+6", tone: "up", history: [40, 42, 45, 47, 48, 50, 51, 53, 54, 55] },
  { key: "conf", label: "Confidence", value: 48, delta: "-3", tone: "down", history: [55, 54, 52, 51, 51, 50, 49, 49, 48, 48] },
  { key: "list", label: "Listening", value: 83, delta: "+1", tone: "up", history: [76, 77, 78, 79, 80, 81, 82, 82, 82, 83] },
];

export const CEFR_TRAJECTORY = [
  { week: "W1", level: 0.7 }, { week: "W2", level: 0.85 }, { week: "W3", level: 1.0 },
  { week: "W4", level: 1.05 }, { week: "W5", level: 1.1 }, { week: "W6", level: 1.18 },
  { week: "W7", level: 1.22 }, { week: "W8", level: 1.27 }, { week: "W9", level: 1.31 },
  { week: "W10", level: 1.34 }, { week: "W11", level: 1.38 }, { week: "W12", level: 1.4 },
];

export const MEMORY_NODES = [
  { id: "m1", category: "grammar", label: "Past simple — irregular verbs", detail: "Confused 'go/went' three times in market scene.", recommendation: "Drill in negotiation scenario · 3 min", tags: ["grammar", "B1"], cefr: "B1 grammar", accent: "cyan", from: "Tue · Market scene", saved_at: "2 days ago" },
  { id: "m2", category: "vocabulary", label: "“presupuesto” — budget", detail: "Resurfaced 4 times this week. Almost owned.", recommendation: "Use in: business call practice", tags: ["vocab", "business"], cefr: "B1 vocab", accent: "blue", from: "Wed · Office call", saved_at: "yesterday" },
  { id: "m3", category: "goal", label: "B2 by July · Berlin relocation", detail: "Trajectory updated — ahead of schedule by 9 days.", recommendation: "Add: pronunciation focus on 'r'", tags: ["goal", "trajectory"], cefr: "goal-locked", accent: "violet", from: "Onboarding · Sept 2", saved_at: "this morning" },
  { id: "m4", category: "pronunciation", label: "Rolling R — improving", detail: "Tongue placement drift detected. AURA noticed clarity in 'perro' today.", recommendation: "Phonetic warmup before any voice call", tags: ["pron", "voice"], cefr: "phonetic", accent: "cyan", from: "Mon · Pronunciation drill", saved_at: "today" },
  { id: "m5", category: "confidence", label: "Family topic hesitation", detail: "Pause of 2.4s when asked about brother. Pattern repeats 3x.", recommendation: "Low-stakes family warmup", tags: ["affect", "pacing"], cefr: "affective", accent: "violet", from: "Fri · Casual chat", saved_at: "3 days ago" },
  { id: "m6", category: "vocabulary", label: "“tener ganas de” — to feel like", detail: "New idiom. First seen in restaurant scene.", recommendation: "Spaced review · 72h", tags: ["vocab", "idiom"], cefr: "A2-B1", accent: "blue", from: "Sun · Restaurant", saved_at: "4 days ago" },
  { id: "m7", category: "grammar", label: "Subjunctive after 'cuando'", detail: "Future subjunctive avoided 5 times. AURA hasn't introduced yet.", recommendation: "Gentle introduction in next session", tags: ["grammar", "B2"], cefr: "B2 grammar", accent: "cyan", from: "Continuous", saved_at: "today" },
  { id: "m8", category: "scene", label: "Market scene · saved", detail: "Strong vocabulary moment. Retains for export.", recommendation: "Use as warmup template", tags: ["scene"], cefr: "—", accent: "blue", from: "Tue · Market scene", saved_at: "2 days ago" },
];

export const SCENARIOS = [
  { id: "s1", title: "Job interview · tech", difficulty: "B1+", duration: "12 min", tag: "Career", hook: "AURA will rehearse the questions you froze on Tuesday.", accent: "cyan" },
  { id: "s2", title: "Negotiate a price", difficulty: "B1", duration: "8 min", tag: "Business", hook: "Reuses your 'presupuesto' word — already 60% owned.", accent: "blue" },
  { id: "s3", title: "First date · cafe", difficulty: "A2-B1", duration: "10 min", tag: "Casual", hook: "Drills the family topic you've been avoiding.", accent: "violet" },
  { id: "s4", title: "Doctor's visit", difficulty: "B1", duration: "9 min", tag: "Travel", hook: "Builds health vocab + polite imperative.", accent: "cyan" },
  { id: "s5", title: "Explain your work", difficulty: "B1-B2", duration: "11 min", tag: "Professional", hook: "Past tenses you missed last week, in context.", accent: "blue" },
  { id: "s6", title: "Storytelling · childhood", difficulty: "B2", duration: "14 min", tag: "Narrative", hook: "Stretches you into past perfect. AURA promises gentle.", accent: "violet" },
];

export const DRILLS = [
  { id: "d1", label: "Past subjunctive · 3 min", weak: true, accent: "cyan" },
  { id: "d2", label: "Rolling R · 4 min", weak: true, accent: "blue" },
  { id: "d3", label: "Restaurant vocab · 5 min", weak: false, accent: "violet" },
  { id: "d4", label: "Numbers & time · 3 min", weak: false, accent: "cyan" },
];

export const GOALS = [
  {
    id: "g1",
    title: "B2 by July",
    subtitle: "Berlin relocation",
    progress: 64,
    eta: "9 days ahead of schedule",
    milestones: [
      { label: "B1 conversation flow", done: true },
      { label: "Past subjunctive ownership", done: false },
      { label: "Negotiation register", done: false },
      { label: "B2 reading speed", done: false },
    ],
  },
  {
    id: "g2",
    title: "Job interview · September",
    subtitle: "Tech role · backend",
    progress: 28,
    eta: "On track",
    milestones: [
      { label: "Self-intro fluent in 60s", done: true },
      { label: "Behavioral STAR answers", done: false },
      { label: "Tech vocabulary depth", done: false },
    ],
  },
  {
    id: "g3",
    title: "Daily 10-minute streak",
    subtitle: "Habit",
    progress: 80,
    eta: "12 days running",
    milestones: [
      { label: "7-day streak", done: true },
      { label: "30-day streak", done: false },
    ],
  },
];

export const COMPLETED_GOALS = [
  { id: "cg1", title: "Read a children's book end-to-end", completed_at: "Oct 18" },
  { id: "cg2", title: "Hold a 5-minute conversation", completed_at: "Sep 24" },
];

export const ACHIEVEMENTS = [
  { id: "a1", label: "First memory saved", date: "Sept 2", accent: "cyan" },
  { id: "a2", label: "10-day streak", date: "Sept 14", accent: "blue" },
  { id: "a3", label: "First full conversation", date: "Sept 24", accent: "violet" },
  { id: "a4", label: "200 words owned", date: "Oct 8", accent: "cyan" },
  { id: "a5", label: "First grammar pattern mastered", date: "Oct 21", accent: "blue" },
];

// Calendar heatmap — last 12 weeks × 7 days, value 0-4 (intensity).
export const HEATMAP = (() => {
  const cells = [];
  const seed = (i) => (i * 9301 + 49297) % 233280;
  for (let i = 0; i < 12 * 7; i++) {
    const r = seed(i) / 233280;
    let v;
    if (r < 0.18) v = 0;
    else if (r < 0.45) v = 1;
    else if (r < 0.7) v = 2;
    else if (r < 0.9) v = 3;
    else v = 4;
    cells.push(v);
  }
  return cells;
})();

export const TODAYS_BRIEF = [
  { id: "tb1", icon: "Brain", title: "Past subjunctive — 3 min drill", reason: "Missed 3x this week", accent: "cyan", time: "3 min" },
  { id: "tb2", icon: "Mic2", title: "Rolling R — phonetic warmup", reason: "Improving · keep it", accent: "blue", time: "4 min" },
  { id: "tb3", icon: "Sparkles", title: "Negotiation scene · live call", reason: "Reuses your 'presupuesto' word", accent: "violet", time: "10 min" },
];

export const LANGUAGES = [
  { code: "es", label: "Spanish (MX)", level: "B1.4", primary: true },
  { code: "fr", label: "French", level: "A2", primary: false },
];

export const NOTIFICATIONS = [
  { id: "n1", text: "Weekly memory digest is ready.", time: "2h ago" },
  { id: "n2", text: "AURA noticed a breakthrough in your fluency.", time: "yesterday" },
];

// Live session script (used by LiveSession demo)
export const LIVE_SCRIPT = [
  { who: "you", caption: "Yesterday I go to the market and I buy some fruits.", text: "Yesterday I go to the market…" },
  { who: "aura", caption: "Same pattern as Tuesday. Try: I went to the market and bought some fruits.", correction: { was: "I go and I buy", now: "I went and bought", rule: "Past simple · irregular" }, text: "Same pattern as Tuesday." },
  { who: "you", caption: "Yesterday I went to the market and bought some fruits.", text: "Yesterday I went to the market and bought some fruits." },
  { who: "aura", caption: "Perfect. I'll bring this back in three days inside a restaurant scene.", memorySaved: { label: "Past simple · market scene", cefr: "B1 grammar" }, text: "Perfect — saved." },
];

// Memory graph nodes (positioned roughly; the page lays them out via force-ish layout)
export const GRAPH_NODES = [
  { id: "n1", label: "past simple", category: "grammar", strength: 0.62, accent: "cyan" },
  { id: "n2", label: "subjunctive", category: "grammar", strength: 0.32, accent: "cyan" },
  { id: "n3", label: "rolling r", category: "pronunciation", strength: 0.71, accent: "cyan" },
  { id: "n4", label: "presupuesto", category: "vocabulary", strength: 0.78, accent: "blue" },
  { id: "n5", label: "tener ganas", category: "vocabulary", strength: 0.41, accent: "blue" },
  { id: "n6", label: "perro", category: "vocabulary", strength: 0.88, accent: "blue" },
  { id: "n7", label: "B2 by July", category: "goal", strength: 0.64, accent: "violet" },
  { id: "n8", label: "tech interview", category: "goal", strength: 0.28, accent: "violet" },
  { id: "n9", label: "market scene", category: "scene", strength: 0.55, accent: "blue" },
  { id: "n10", label: "office call", category: "scene", strength: 0.38, accent: "blue" },
  { id: "n11", label: "family topic", category: "confidence", strength: 0.42, accent: "violet" },
  { id: "n12", label: "voice print", category: "voice", strength: 0.92, accent: "cyan" },
];

export const GRAPH_EDGES = [
  ["n1", "n9"], ["n1", "n10"], ["n1", "n2"], ["n2", "n7"], ["n3", "n6"], ["n3", "n12"],
  ["n4", "n10"], ["n4", "n8"], ["n5", "n9"], ["n6", "n9"], ["n7", "n2"], ["n7", "n4"],
  ["n8", "n4"], ["n8", "n10"], ["n9", "n10"], ["n11", "n9"], ["n11", "n7"], ["n12", "n3"],
];
